import ClientUtils from './utils';

const environment = process.env.NWEA_ENV || 'team16';

const baseUrl = !__BATCH__
    ? '/reporting-api/v3/reporting-api'
    : `https://reportingapi.${environment}.map2.nweacolo.pvt/reporting-api/v3/reporting-api`;
const lcBaseUrl = !__BATCH__
    ? '/reporting-api/v3/lcapi'
    : `https://reportingapi.${environment}.map2.nweacolo.pvt/reporting-api/v3/lcapi`;

export default {
    getSchools: (partnerBid, termBid, educatorBid, callback) => {
        const url = `${baseUrl}/partners/${partnerBid}/schools`;
        const params = {
            term: termBid,
            educator: educatorBid,
        };

        return ClientUtils.makeGetRequest(url, callback, params);
    },
    getInstructors: (partnerBid, schoolBid, termBid, callback) => {
        const url = `${baseUrl}/partners/${partnerBid}/schools/${schoolBid}/instructors`;
        const params = { term: termBid };

        return ClientUtils.makeGetRequest(url, callback, params);
    },
    getClasses: (partnerBid, schoolBid, educatorBid, termBid, callback, optionalFailureCallback = null) => {
        const url = `${baseUrl}/partners/${partnerBid}/schools/${schoolBid}/classes`;
        const params = {
            term: termBid,
            educator: educatorBid,
        };

        return ClientUtils.makeGetRequest(url, callback, params, optionalFailureCallback);
    },
    getStudents: (partnerBid, schoolBid, classBid, termBid, callback, optionalFailureCallback = null) => {
        let url;
        if (process.env.ROUTE_TO_MOCK_SERVER === 'true') {
            url = `http://localhost:3001/getStudents`;
        } else {
            url = `${baseUrl}/partners/${partnerBid}/schools/${schoolBid}/classes/${classBid}/students`;
        }
        let params = { term: termBid };
        return ClientUtils.makeGetRequest(url, callback, params, optionalFailureCallback);
    },
    getLearningContinuumData: (testkey, callback, failureCallback) => {
        const url = `${lcBaseUrl}/tests/${testkey}/learning-continuum`;

        return ClientUtils.makeGetRequest(url, callback, null, failureCallback);
    },
};
